<template>
  <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home' }"
              >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>产品管理</el-breadcrumb-item>
          <el-breadcrumb-item>产品码管理</el-breadcrumb-item>
      </el-breadcrumb>
      <el-page-header @back="goBack"></el-page-header>
      <!-- 筛选 -->
      <el-card style="margin-top: 15px">
          <el-row class="title_row">
              <el-col>
                  <span class="title_class">信息筛选</span>
              </el-col>
          </el-row>
          <el-form
              :model="queryForm"
              class="filter_Form"
              label-width="100px"
              ref="queryFormRef"
          >
              <el-row :gutter="10">
                  <el-col :span="6">
                      <el-form-item label="赛季" prop="season">
                          <el-select
                              placeholder="请选择赛季"
                              style="width: 100%"
                              v-model="queryForm.season"
                              clearable
                          >
                              <el-option
                                  v-for="item in dict_season"
                                  :key="item.dictValue"
                                  :label="item.dictLabel"
                                  :value="item.dictValue"
                              ></el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
                  <el-col :span="6">
                      <el-form-item label="解锁赛程" prop="raceSchedule">
                          <el-select
                              placeholder="请选择"
                              style="width: 100%"
                              v-model="queryForm.raceSchedule"
                              clearable
                          >
                              <el-option
                                  v-for="item in codeTypeList"
                                  :key="item.productDetailId"
                                  :label="item.productName"
                                  :value="item.productDetailId"
                              ></el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
                  <el-col :span="6">
                      <el-form-item label="是否使用" prop="isUsed">
                          <el-select
                              placeholder="请选择"
                              style="width: 100%"
                              v-model="queryForm.isUsed"
                              clearable
                          >
                              <el-option
                                  v-for="item in dict_isUsed"
                                  :key="item.dictValue"
                                  :label="item.dictLabel"
                                  :value="item.dictValue"
                              ></el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
                  <el-col :span="6">
                      <el-form-item label="创建人" prop="creator">
                          <el-input
                              v-model="queryForm.creator"
                              placeholder="请输入"
                              clearable
                          ></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="6">
                      <el-form-item label="兑换码" prop="code">
                          <el-input
                              v-model="queryForm.code"
                              placeholder="请输入"
                              clearable
                          ></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="6">
                        <el-form-item label="描述信息" prop="codeDescription">
                            <el-input
                                v-model="queryForm.codeDescription"
                                placeholder="请输入"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
              </el-row>
          </el-form>
          <el-row :gutter="20" type="flex" justify="end">
              <el-col :span="2">
                  <el-button
                      type="primary"
                      style="width: 100%"
                      @click="getDataList('search')"
                      >查询</el-button
                  >
              </el-col>
              <el-col :span="2">
                  <el-button
                      type="primary"
                      plain
                      style="width: 100%"
                      @click="reset"
                      >重置</el-button
                  >
              </el-col>
          </el-row>
      </el-card>
      <!-- 学校列表 -->
      <el-card style="margin-top: 15px">
          <el-row class="title_row" align="middle" type="flex">
              <el-col :span="9">
                  <span class="title_class">兑换码信息</span>
              </el-col>
              <el-col :span="15">
                  <div class="div_algin_right">
                      <el-button
                          type="primary"
                          @click="editInfoDialogVisible = true"
                          >新增兑换码+</el-button
                      >
                      <el-button
                          type="primary"
                          @click="downloadCodeData"
                          icon="el-icon-download"
                          >批量导出</el-button
                      >
                  </div>
              </el-col>
          </el-row>
          <el-table
              header-cell-class-name="tableHeaderStyle"
              :data="dataList"
              border
              stripe
          >
              <el-table-column label="序号" type="index"></el-table-column>
              <el-table-column
                  label="赛程"
                  prop="raceSchedule"
                  :formatter="codeTypeFormatter"
              ></el-table-column>
              <!-- <el-table-column label="赛季" prop="season"></el-table-column> -->
              <el-table-column label="分配赛区" prop="districtNmae"></el-table-column>
              <el-table-column label="兑换码" prop="code"></el-table-column>
              <el-table-column label="有效天数" prop="days">
                  <template slot-scope="scope">
                      <span v-if="!scope.row.days">-</span>
                      <span v-else>{{ scope.row.days }}</span>
                  </template>
              </el-table-column>
              <el-table-column label="是否使用" prop="isUsed">
                  <template slot-scope="scope">
                      <el-tag
                          type="success"
                          v-if="scope.row.isUsed === true"
                          size="mini"
                          >已使用</el-tag
                      >
                      <el-tag type="warning" v-else size="mini"
                          >未使用</el-tag
                      >
                  </template>
              </el-table-column>
              <el-table-column
                  label="使用人"
                  prop="userName"
              ></el-table-column>
              <el-table-column
                  label="使用时间"
                  prop="useTime"
              ></el-table-column>
              <el-table-column
                  label="创建人"
                  prop="creator"
              ></el-table-column>
              <el-table-column
                  label="描述信息"
                  prop="codeDescription"
              ></el-table-column>
              <el-table-column label="操作" width="100px">
                  <template slot-scope="scope">
                      <el-button
                          type="text"
                          icon="el-icon-delete"
                          size="small"
                          @click="handleDelete(scope.row)"
                          >删除</el-button
                      >
                  </template>
              </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="queryForm.pageNum"
              :page-sizes="[10, 20, 40, 80]"
              :page-size="queryForm.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
          >
          </el-pagination>
      </el-card>
      <!-- 编辑信息的dialog -->
      <el-dialog
          title="添加兑换码信息"
          :visible.sync="editInfoDialogVisible"
          width="40%"
          @close="editInfoDialogClose"
          @open="handleDialogOpen"
      >
          <el-form
              :model="editInfoForm"
              label-width="140px"
              ref="editInfoFormRef"
              :rules="editInfoRules"
              style="width: 100%"
          >
              <el-row>
                  <el-col :span="20">
                      <el-form-item label="解锁产品类型" prop="raceSchedule">
                          <el-select
                              placeholder="请选择"
                              style="width: 100%"
                              v-model="editInfoForm.raceSchedule"
                              value-key="productDetailId"
                              @change="codeTypeChange($event)"
                          >
                              <el-option
                                  v-for="item in codeTypeList"
                                  :key="item.productDetailId"
                                  :label="item.productName"
                                  :value="item.productDetailId"
                              ></el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
                  <el-col :span="20">
                      <el-form-item label="生成数量" prop="num">
                          <el-input
                              v-model="editInfoForm.num"
                              placeholder="请输入"
                              clearable
                          ></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="20">
                      <el-form-item label="天数" prop="days">
                          <el-input
                              v-model="editInfoForm.days"
                              placeholder="请输入"
                              type="number"
                              clearable
                          ></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="20">
                      <el-form-item label="赛区" prop="districtId">
                          <el-select
                              v-model="editInfoForm.districtId"
                              placeholder="请选择赛区"
                              clearable
                              style="width: 100%"
                              filterable
                          >
                              <el-option
                                  v-for="item in districtList"
                                  :key="item.id"
                                  :label="item.districtName"
                                  :value="item.id"
                              ></el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
              </el-row>
              <el-row>
                  <el-col :span="20">
                      <el-form-item label="描述信息" prop="codeDescription">
                          <el-input
                              maxlength="100"
                              type="textarea"
                              v-model="editInfoForm.codeDescription"
                              placeholder="请输入描述信息(不超过100字)"
                              clearable
                          ></el-input> </el-form-item
                  ></el-col>
              </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
              <el-button @click="editInfoDialogVisible = false"
                  >取 消</el-button
              >
              <el-button type="primary" @click="editInfo">保 存</el-button>
          </span>
      </el-dialog>
  </div>
</template>

<script>
import { queryOverseasConversionCodeList, addOverseasConversionCode, updateOverseasConversionCode, queryDistrictPage, deleteOverseasConversionCode } from '@/http/api'
export default {
  data () {
    return {
      changeQueryForm: {
        codeDescription: ''
      },
      distributionStateDialogVisible: false,
      provincesSchoolList: [],
      editInfoDialogVisible: false,
      showEditInfoForm: false,
      dataList: [],
      total: 0,
      userInfoData: {},
      userInfoForm: {
        phone: ''
      },
      queryForm: {
        season: this.$chnEngStatusCode.defaultSeason,
        productDetailId: null,
        pageNum: 1,
        pageSize: 10,
        state: null,
        creator: null,
        codeDescription: ''
      },
      editInfoForm: {
        raceSchedule: null,
        num: null,
        days: null,
        codeDescription: '',
        districtId: null // 赛区ID
      },
      districtList: [], // 赛区列表
      changeQueryFormRules: {
        allocation: { required: true, message: '请选择', trigger: 'change' }
      },
      userInfoRules: {
        phone: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      dict_season: [],
      editInfoRules: {
        codeDescription: [{ required: true, message: '请输入', trigger: 'blur' }],
        raceSchedule: { required: true, message: '请选择', trigger: 'change' },
        num: [{ required: true, message: '请输入', trigger: 'blur' }],
        districtId: [{ required: true, message: '请选择赛区', trigger: 'change' }]
      },
      codeTypeList: [
        {
          productDetailId: 1,
          productName: '初选',
          productFlag: 'INDIVIDUAL_PRELIMINARY',
          productId: 1
        },
        {
          productDetailId: 2,
          productName: '区域决选',
          productFlag: 'INDIVIDUAL_FINAL',
          productId: 2
        }
      ],
      addTimepickerOptionsStart: {},
      addTimepickerOptionsEnd: {},
      dict_isUsed: [
        {
          dictValue: false,
          dictLabel: '未使用'
        },
        {
          dictValue: true,
          dictLabel: '已使用'
        }
      ]
    }
  },
  created () {
    this.$userInfo.getDataList(this, 't_season', this.$store.state.flag).then(value => {
      this.dict_season = value
      this.getDataList()
    })
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 获取列表信息
    getDataList (getType) {
      if (getType === 'search') {
        this.queryForm.pageNum = 1
        this.queryForm.pageSize = 10
      }
      queryOverseasConversionCodeList(this.queryForm).then((res) => {
        console.log('queryConversionCodeList', res)
        this.dataList = res.data.list
        this.total = res.data.total
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 选择产品回调
    codeTypeChange (e) {
      for (const key in this.codeTypeList) {
        if (Object.prototype.hasOwnProperty.call(this.codeTypeList, key)) {
          const element = this.codeTypeList[key]
          if (element.productDetailId === e) {
            this.editInfoForm.productFlag = element.flag
            this.editInfoForm.raceSchedule = element.productId
            this.editInfoForm.productDetailId = element.productDetailId
          }
        }
      }
    },
    codeTypeFormatter (data) {
      var temp = '未设置'
      for (const key in this.codeTypeList) {
        if (Object.hasOwnProperty.call(this.codeTypeList, key)) {
          const element = this.codeTypeList[key]
          if (element.productDetailId === data.raceSchedule) {
            temp = element.productName
          }
        }
      }
      return temp
    },
    // 保存新增code点击事件
    editInfo () {
      this.$refs.editInfoFormRef.validate(async valid => {
        if (!valid) return
        addOverseasConversionCode(this.editInfoForm).then((res) => {
          this.editInfoDialogVisible = false
          this.$message.success('新增成功！')
          this.$refs.editInfoFormRef.resetFields()
          this.reset()
        }).catch((err) => {
          console.log('返回的err', err)
        })
      })
    },
    showChangePopViiew (rowData) {
      this.changeQueryForm.codeDescription = rowData.codeDescription
      this.changeQueryForm.id = rowData.id
      this.distributionStateDialogVisible = true
    },
    changeState () {
      updateOverseasConversionCode(this.changeQueryForm).then((res) => {
        this.distributionStateDialogVisible = false
        this.$message.success('修改成功！')
        this.$refs.changeQueryFormRef.resetFields()
        this.reset()
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    // 弹窗打开
    handleDialogOpen () {
      // 打开弹窗时获取赛区列表
      this.getDistrictList()
    },
    // 获取赛区列表
    getDistrictList () {
      const params = {
        regionType: 'overseas',
        pageNum: 1,
        pageSize: 10000
      }
      queryDistrictPage(params).then((res) => {
        console.log('getDistrictList', res)
        this.districtList = res.data.list || []
      }).catch((err) => {
        console.log('获取赛区列表失败', err)
        this.$message.error('获取赛区列表失败')
      })
    },
    // 弹窗关闭
    editInfoDialogClose () {
      this.showEditInfoForm = false
      this.editInfoForm.schoolArea = null
      this.editInfoForm.districtId = null
      this.$refs.editInfoFormRef.resetFields()
    },
    // 重置搜索条件
    reset () {
      this.$refs.queryFormRef.resetFields()
      this.getDataList()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getDataList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getDataList()
    },
    downloadCodeData () {
      var downLoadUrl = this.$env.baseIP + 'overseasMatchCode/exportConversionCodeList'
      this.$downLoadFile.downLoadFileWithFile(this, downLoadUrl, '兑换码-导出', this.queryForm)
    },
    // 删除兑换码
    handleDelete (row) {
      this.$confirm('确认删除该兑换码吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          id: row.id
        }
        deleteOverseasConversionCode(params).then((res) => {
          console.log('deleteOverseasConversionCode', res)
          this.$message.success('删除成功')
          this.getDataList()
        }).catch((err) => {
          console.log('删除失败', err)
          this.$message.error('删除失败')
        })
      }).catch(() => {
        // 用户取消删除，不做任何操作
      })
    }
  }
}
</script>

<style lang="less" scoped>
.div_algin_right {
  text-align: right;
}
</style>
